const t = {
  selectedStationCode: void 0,
  isListExpanded: !1,
  isFilterModalOpen: !1,
  selectedFilters: /* @__PURE__ */ new Map(),
  selectedQuickFilter: void 0
};
function i(e, l) {
  switch (l.type) {
    case "TOGGLE_FILTER_MODAL":
      return { ...e, isFilterModalOpen: l.payload.isFilterModalOpen };
    case "TOGGLE_LIST":
      return { ...e, isListExpanded: l.payload.isListExpanded };
    case "SELECT_STATION":
      return { ...e, selectedStationCode: l.payload.selectedStationCode };
    case "DESELECT_STATION":
      return { ...e, selectedStationCode: void 0 };
    case "ADD_FILTER": {
      const d = new Map(e.selectedFilters);
      return d.set(l.payload.filterName, l.payload.filterValue), { ...e, selectedFilters: d };
    }
    case "REMOVE_FILTER": {
      const d = new Map(e.selectedFilters);
      return d.delete(l.payload.filterName), { ...e, selectedFilters: d };
    }
    case "CLEAR_ALL_FILTERS":
      return { ...e, selectedFilters: /* @__PURE__ */ new Map(), selectedQuickFilter: void 0 };
    case "SET_FILTERS":
      return { ...e, selectedFilters: l.payload.filters };
    default:
      return { ...e };
  }
}
export {
  i as FindStationReducer,
  t as InitialFindStationState
};
